<template>
  <b-row>
    <div class="col-md-6">
      <card class="stacked-form">
        <form v-on:submit.prevent="doSubmit">

          <fg-input :required="true" for-input="name" type="text" name="name" id="name" label="Nama" placeholder="Masukkan nama" v-validate="modelValidations.name" :error="errors.first('name')" v-model="model.name" data-vv-as="Name"/>

          <fg-input :required="true" for-input="address" type="text" name="address" id="address" label="Alamat" placeholder="Enter address" v-model="model.address"/>

          <fg-input :required="true" for-input="email" type="text" name="email" id="email" label="Email" placeholder="Masukkan email" v-validate="modelValidations.email" :error="errors.first('email')" v-model="model.email" data-vv-as="Email"/>

          <fg-input :required="true" for-input="phone" type="text" name="phone" id="phone" label="Telelpon" placeholder="Masukkan nomor telepon" v-validate="modelValidations.phone" :error="errors.first('phone')" v-model="model.phone" data-vv-as="Phone"/>

          <div class="form-group" v-bind:class="{ 'has-error': errors.first('registeredDate') }">
            <label>Terdaftar tanggal *</label>
            <el-date-picker v-model="fakeModel.registeredDate" placeholder="Date Of Birth" ></el-date-picker>
            <input v-model="model.registeredDate" type="hidden" v-validate="modelValidations.registeredDate" name="registeredDate" data-vv-as="date of birth"/>
            <slot name="infoBlock"></slot>
            <slot name="helpBlock">
              <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('registeredDate')">
                {{ errors.first('registeredDate') }}
              </div>
            </slot>
          </div>

          <cancel-button/>

          <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id === undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
          
        </form>
      </card>
    </div>
  </b-row>
</template>
<script>
  import { DatePicker, Select, Option, Switch } from 'element-ui'
  import { Radio } from '@/components/index'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: {
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      [DatePicker.name]: DatePicker,
      LRadio: Radio,
      LSwitch: Switch,
      Treeselect
    },
    data () {
      return {
        downPaymentDisabled: true,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          supplier: window.AppConfig.apiUrl + 'supplier'
        },
        options: [
          { text: 'Male', value: '0' },
          { text: 'Famele', value: '1' }
        ],
        productionCost: 0,
        supplierList: [],
        fakeModel: {
          registeredDate: ''
        },
        ppn: 0,
        model: {
          name: '',
          email: '',
          phone: '',
          address: '',
          registeredDate: ''
        },
        modelValidations: {
          name: {
            required: true
          },
          email: {
            required: true
          },
          phone: {
            required: true
          },
          address: {
            required: true
          },
          registeredDate: {
            required: true
          }
        }
      }
    },
    watch: {
      '$route.params.id': function (val) {
        this.initData()
      },
      'fakeModel.registeredDate' (value) {
        this.model.registeredDate = value !== null ? this.$moment(value).format('YYYY-MM-DD') : null
      }
    },
    mounted () {
      this.initData()
    },
    methods: {
      initData () {
        if (this.$route.params.id !== undefined) {
          this.getDetail()
        }
        setTimeout(() => {
          document.getElementsByName('name')[0].focus()
        }, 100)
      },
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.supplier + '/' + this.$route.params.id)
        .then(response => {
          this.model.name = response.data.name
          this.model.email = response.data.email
          this.model.phone = response.data.phone
          this.model.address = response.data.address
          this.model.registeredDate = response.data.registered_date
          this.fakeModel.registeredDate = response.data.registered_date
          this.model.personInCharge = response.data.personInCharge
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      doSubmit () {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.saveButtonData.isLoading = true
            if (this.$route.params.id !== undefined) {
              this.$http.patch(this.apiUrl.supplier + '/' + this.$route.params.id, this.model).then(response => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/success', 'User has been updated.')
                window.location.href = document.URL.replace('/edit', '')
              }).catch(error => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            } else {
              this.$http.post(this.apiUrl.supplier, this.model).then(response => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/success', 'User has been added.')
                window.location.href = document.URL.replace('/create', '/' + response.data.id)
              }).catch(error => {
                this.saveButtonData.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      formatNumber (num) {
        return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
      }
    }
  }
</script>

<style scooped>
  .fixed-top-selling {
    position: fixed;
    float: right !important;
    /* top: 0; */
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
  .fixed-top-downpayment {
    position: fixed;
    float: right !important;
    top: 48%;
    /* right: 0; */
    /* left: 0; */
    width: 37%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Suppliers/Form.vue